// Instagram Graph API — uses the Facebook Page access token.
// The IG Business Account ID is derived from the linked Facebook Page.

const FB_BASE = "https://graph.facebook.com/v25.0";

async function fbFetch(url) {
  const res = await fetch(url);
  const body = await res.json();
  if (!res.ok || body.error) throw new Error(body.error?.message || `API error ${res.status}`);
  return body;
}

// Step 1 — resolve the Instagram Business Account ID from the Facebook Page.
// Result is cached by the caller so this only fires once per session.
export async function getInstagramAccountId(pageId, token) {
  const data = await fbFetch(
    `${FB_BASE}/${pageId}?fields=instagram_business_account&access_token=${token}`
  );
  const igId = data.instagram_business_account?.id;
  if (!igId) throw new Error("No Instagram business account linked to this Facebook page");
  return igId;
}

// Step 2 — fetch live metrics using the IG Business Account ID.
export async function getInstagramStats(igId, token) {
  const data = await fbFetch(
    `${FB_BASE}/${igId}?fields=followers_count,media_count,follows_count&access_token=${token}`
  );
  return {
    followersCount: data.followers_count ?? 0,
    mediaCount:     data.media_count     ?? 0,
    followsCount:   data.follows_count   ?? 0,
  };
}
